/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Jr_4_WInputs */

const en_cp_jr_4_w = /** @type {(inputs: Cp_Jr_4_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`next semester`)
};

const id_cp_jr_4_w = /** @type {(inputs: Cp_Jr_4_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`semester berikutnya`)
};

/**
* | output |
* | --- |
* | "next semester" |
*
* @param {Cp_Jr_4_WInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_jr_4_w = /** @type {((inputs?: Cp_Jr_4_WInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Jr_4_WInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_jr_4_w(inputs)
	return en_cp_jr_4_w(inputs)
});